import { BannerSection, CategoryNav, FloatingShopCart, Footer, Nav, TopNav, FloatingCategory, Authentication } from 'components'
import { FloatingSection } from 'components/FloatingSection'
import { Outlet, useLocation } from 'react-router-dom'
import { useContext, useEffect } from 'react'

import './index.scss'
import { AppContext } from 'App'
import { updateDestination } from 'slices/auth'
import { useAppDispatch } from 'store/hooks'

interface Props { };

export function Root(props: Props) {
    const { SetShowLogin, showLogin, auth_properties, setAuth_properties} = useContext(AppContext)
    const location = useLocation()
    const dispatch = useAppDispatch()

    // login, register, forgot-password,
    // handleAddToCart: () => void
    // auth_type - login, register, forgot-password
    // auth_name - Login with your email and password, Signing Up, Forget Password
    // auth_title - Login with your email and password, Create an account with email, Reset Your Password
    // auth_button - login, register, recover password
    // auth_comment - Not have a account ?, Already have a account ?
    useEffect(() => {

        switch (location.pathname.toLowerCase()) {
            case '/login':
                setAuth_properties({
                    auth_type: 'login',
                    auth_name: 'Login',
                    auth_title: 'Login with your email and password',
                    auth_button: 'login',
                    auth_comment: 'Not have an account?',
                    auth_comment_name: 'register',
                })
                SetShowLogin(true)
                break;
            case '/register':
                setAuth_properties({
                    auth_type: 'register',
                    auth_name: 'Signing Up',
                    auth_title: 'Create an account with email',
                    auth_button: 'register',
                    auth_comment: 'Already have a account?',
                    auth_comment_name: 'login',
                })
                SetShowLogin(true)
                break;
            case '/forgot-password':
                setAuth_properties({
                    auth_type: 'forgot-password',
                    auth_name: 'Forget Password',
                    auth_title: 'Reset Your Password',
                    auth_button: 'recover password',
                    auth_comment: 'Not have a account?',
                    auth_comment_name: 'register',
                })
                SetShowLogin(true)
                break;

            default:
                setAuth_properties({
                    auth_type: 'login',
                    auth_name: 'Login',
                    auth_title: 'Login with your email and password',
                    auth_button: 'login',
                    auth_comment: 'Not have an account?',
                    auth_comment_name: 'register',
                })
                SetShowLogin(false)
                dispatch(updateDestination(''))
                break;
        }
    }, [location])

    return (

        <div className="root">
            <TopNav />
            <div className="sticky">
                <Nav />
                <CategoryNav />
            </div>
            <Outlet />
            <FloatingCategory />
            <Authentication showLogin={showLogin} auth_properties={auth_properties} SetShowLogin={SetShowLogin} />
            <FloatingSection />
            <FloatingShopCart />
            <BannerSection />
            <Footer />
        </div>
    )
}
